export default function WindowTypes() {
  const windowTypes = [
    {
      icon: 'ri-window-line',
      title: 'Fenêtres PVC',
      description: 'Réparation mécanismes, quincaillerie, joints et vitrages',
      link: '/reparation-fenetre-pvc-lyon',
      color: 'from-blue-500 to-blue-600',
    },
    {
      icon: 'ri-building-line',
      title: 'Fenêtres Aluminium',
      description: 'Réparation systèmes coulissants, joints et mécanismes',
      link: '/reparation-fenetre-alu-lyon',
      color: 'from-gray-500 to-gray-600',
    },
    {
      icon: 'ri-home-4-line',
      title: 'Fenêtres Bois',
      description: 'Rénovation boiseries, réparation quincaillerie et peinture',
      link: '/reparation-fenetre-bois-lyon',
      color: 'from-amber-600 to-amber-700',
    },
    {
      icon: 'ri-layout-line',
      title: 'Baies Vitrées',
      description: 'Réparation rails, roulettes et systèmes de fermeture',
      link: '/reparation-baie-vitree-lyon',
      color: 'from-cyan-500 to-cyan-600',
    },
  ];

  return (
    <section id="window-types" className="bg-gradient-to-b from-gray-50 to-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16 animate-fade-in-up">
          <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
            TOUS TYPES DE MENUISERIES
          </span>
          <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mt-4 mb-6">
            Nous Réparons Tous Types de Fenêtres
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            <strong>Spécialistes de la réparation uniquement.</strong> Nous intervenons sur toutes vos menuiseries existantes, quel que soit le matériau.
          </p>
        </div>

        {/* Window Types Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {windowTypes.map((type, index) => (
            <a
              key={index}
              href={type.link}
              className={`group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:-translate-y-2 cursor-pointer animate-fade-in-up delay-${(index + 1) * 100}`}
            >
              {/* Icon Header */}
              <div className={`bg-gradient-to-br ${type.color} p-6 lg:p-8 text-center transition-all duration-300 group-hover:scale-105`}>
                <div className="w-16 h-16 lg:w-20 lg:h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:rotate-12">
                  <i className={`${type.icon} text-white text-3xl lg:text-4xl`}></i>
                </div>
                <h3 className="text-lg lg:text-xl font-bold text-white">{type.title}</h3>
              </div>

              {/* Content */}
              <div className="p-5 lg:p-6">
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {type.description}
                </p>
                <div className="flex items-center text-teal-600 font-semibold text-sm group-hover:text-teal-700">
                  <span>En savoir plus</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Info Box */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 lg:p-12 border border-teal-100 animate-fade-in-up delay-500 hover-lift">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                Nous Ne Posons Pas de Fenêtres Neuves
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Notre expertise se concentre exclusivement sur la <strong>réparation et l'entretien de vos menuiseries existantes</strong>. Nous ne vendons pas de fenêtres neuves, nous prolongeons la durée de vie des vôtres. Découvrez <a href="/blog/renovation-fenetres-anciennes-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium transition-colors">comment rénover vos fenêtres anciennes</a>.
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-3 hover:translate-x-2 transition-transform cursor-pointer">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                  <span className="text-gray-700 text-sm font-medium">90% des fenêtres sont réparables</span>
                </div>
                <div className="flex items-center space-x-3 hover:translate-x-2 transition-transform cursor-pointer">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                  <span className="text-gray-700 text-sm font-medium">3 à 5 fois moins cher qu'un remplacement</span>
                </div>
                <div className="flex items-center space-x-3 hover:translate-x-2 transition-transform cursor-pointer">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                  <span className="text-gray-700 text-sm font-medium">Prolongation de 10 à 15 ans minimum</span>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-sm w-full hover-scale transition-transform duration-300">
                <div className="w-20 h-20 lg:w-24 lg:h-24 bg-gradient-to-br from-teal-500 to-cyan-400 rounded-full flex items-center justify-center mx-auto mb-6 animate-float">
                  <i className="ri-tools-fill text-white text-4xl lg:text-5xl"></i>
                </div>
                <div className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">100%</div>
                <div className="text-lg font-semibold text-gray-700 mb-2">Réparation</div>
                <div className="text-sm text-gray-600">Pas de pose neuve</div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10 lg:mt-12 animate-fade-in-up delay-600">
          <a
            href="#contact"
            className="inline-flex items-center space-x-3 bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-all hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer btn-ripple"
          >
            <i className="ri-tools-line text-xl"></i>
            <span>Demander une Réparation</span>
          </a>
        </div>
      </div>
    </section>
  );
}
